import React from 'react';

const Header = () => {
  return (
    <header className="bg-blue-500 text-white p-4">
      <h1 className="text-2xl font-bold">Forecasting Study</h1>
    </header>
  );
};

export default Header;